module.exports = __webpack_public_path__ + "static/media/report_feedback_dude.8eba3350.png";